export enum BusinessPartnerTypeEnum {
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  BUILDING_AUTHORITY = 'BUILDING_AUTHORITY',
  STATE_BUILDING_AUTHORITY = 'STATE_BUILDING_AUTHORITY',
  INSTALLER = 'INSTALLER',
  CHIMNEY_SWEEPER = 'CHIMNEY_SWEEPER'
}
